
import { Component, Prop, Vue } from 'vue-property-decorator'

import BrebModel from '../models/Breb'

import EPaymentInfo from './PaymentInfo.vue'

@Component({
  components: {
    EPaymentInfo,
  },
})
export default class Breb extends Vue {
  @Prop({ required: true }) readonly breb!: BrebModel
}
